import { statusSchema, stringRequiredSchema } from "utils/validation/validationHelpers";
import { array, object, string } from 'yup';
import errorMessages from 'utils/validation/errorMessages';
import { isHTMLContentEmpty } from "helpers/common";

const chatterLessonValidation = object().shape({
    title: stringRequiredSchema,
    description: string()
        .test('is-not-empty', 'This field is required', (value) => !isHTMLContentEmpty(value))
        .required('This field is required'),
    files: array().min(1, errorMessages.required).of(object().shape({
        attachment_key: stringRequiredSchema,
        attachment_name: stringRequiredSchema
    })),
    tags: array().min(1, "Atleast select one tag"),
    // status: statusSchema
});

export default chatterLessonValidation;